<script>
	//export let name;

	import { onMount } from "svelte";

	import LabelInput from './label-input.svelte';
	import InfoPopup from './info-popup.svelte';
	import TimeDraw from './timeDraw.svelte';

	let loading = true
	let ladebereich_sichtbar = true
	let impressum_sichtbar = false
	let vorlagen = []
	let rezept = null
	let teig_props = null
	let avail_units = null
	let sel_unit = 'g'
	let exported_rezept = ''

	let zutaten_text = "Mehlkochstück\n50g Dinkelvollkornmehl\n50g Wasser\n\nHauptteig\nMehlkochstück\n155g Dinkelmehl 1050\n125g Wasser (30°C)\n160g ASG (TA200, 5°C)";

	let knetenBezeichnungen = ['Undefiniert', 'Nur vermischen', 'wenig', 'viel']

	let run = false

	let TimeDrawRef // bind:this auf Komponente, um Funktion in showTool aufzurufen


	// check if website is run locally or on S3
	let Server
	let Server_debug_msg = ''
	if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
		Server = 'http://127.0.0.1:5000/';
		Server_debug_msg = 'LOKAL' }
	else Server = 'http://brotcraft.herokuapp.com'

	onMount(() => {
			load_labels()
	});

// async function load_labels() {
// 	loading_defaults = true;
// 	const res = await fetch(Server+"/load_labels", {
// 		method: 'GET',
// 		headers: {'Content-Type': 'application/json', },
// 	})
// 	const json = await res.json();
// 	vorlagen = await json.vorlagen;
// 	avail_units = await json.avail_units;
// 	loading_defaults = false;
// }

	// async function update(anpassung, wert, params) {
	// 		loading = true;
	// 		//console.info('aufrag', anpassung)
	// 		const res = await fetch('http://localhost:5000/update', {
	// 					method: 'POST',
	// 					headers: {'Content-Type': 'application/json', },
	// 					body: JSON.stringify( {'rezept':rezept, 'selected_unit':sel_unit, 'anpassung':anpassung, 'wert':wert, 'params':params} )
	// 				})
	// 		const json = await res.json();
	// 		// Bem: Sowohl fetch als auch .json() geben zunächst nur ein Promise zurück. Daher mit await auf die erfolgreiche Auflösung des Versprechens warten.
	//
	// 		rezept = json.rezept;
	// 		console.info(rezept)
	// 		teig_props = []
	// 		teig_props.push(rezept.teig_props) // vom summierten Teig
	// 		rezept.teige.forEach(function(item, index, array) {
	// 			teig_props.push(item['teig_props']) // und von den Subteigen
	// 		})
	//
	// 		//TiemDrawRef.update_schritte(rezept.schritte)
	// 		TimeDrawRef.make_everything_new() // timetable0 wird im Komponentenaufruf festgelegt
	//
	// 		loading = false;
	// }

	function export_rezept(rezept) {
		exported_rezept = ''
		rezept.teige.forEach(function(subteig, index, array) {
			exported_rezept += subteig.name+'\n'
			subteig.zutaten.forEach(function(z,i2,a2) {
				exported_rezept += z.m+'g '+z.label_de + '\n'
				})
			exported_rezept += '\n'
			})
	}

	async function load_labels() {
		fetch(Server+"/load_labels", {
			method: 'GET',
			headers: {'Content-Type': 'application/json', },
		})
		.then(r => r.json())
		.then(json => {
			vorlagen = json.vorlagen
			avail_units = json.avail_units
		})
		.catch(error => console.log('load_labels!', error))
		.finally(() => loading = false)
	}

	async function update(anpassung, wert, params) {
			loading = true;
			fetch(Server+'/update', {
						method: 'POST',
						headers: {'Content-Type': 'application/json', },
						body: JSON.stringify( {'rezept':rezept, 'selected_unit':sel_unit, 'anpassung':anpassung, 'wert':wert, 'params':params} )
					})
			.then(r => r.json())
			.then(json => {
				rezept=json.rezept;
				console.info('rezept:',rezept)

				export_rezept(rezept) // speichert Teignamen mit Zutaten in exported_rezept

				//teig_props = []
				//teig_props.push(rezept.teig_props) // vom summierten Teig
				// rezept.teige.forEach(function(item, index, array) {
				// 	teig_props.push(item['teig_props']) // und von den Subteigen
				//   })
			})
			.catch(error => {
				console.log('update!', error);
			})
			.finally(() => {
				loading = false
				TimeDrawRef.make_everything_new() // timetable0 wird im Komponentenaufruf festgelegt
				ladebereich_sichtbar = false
			})

	}


	function showRezeptauswahl(element, e) {
		console.info('test', e, element)
		var x = document.getElementsByClassName("rezeptWahl");
		for (var i = 0; i < x.length; i++) {
			x[i].style.display = 'none';
		}
		document.getElementById(element).style.display = 'block';

		var menuItems = document.getElementsByClassName("menuItem");
		for (var i = 0; i < x.length; i++) {
			menuItems[i].classList.remove("menuSelected");
		}
		e.target.classList.add("menuSelected");
	}

	function showTool(element) {
		var x = document.getElementsByClassName("rechte_Anzeige");
		for (var i = 0; i < x.length; i++) {
			x[i].style.display = 'none';
		}
		document.getElementById(element).style.display = 'block';
		if (element == 'timetable') { // ===> wird auch schon nach jedem update() gemacht und ist hier trotzdem noch mal nötig, sonst sind Linien falsch
			TimeDrawRef.make_everything_new() // timetable0 wird im Komponentenaufruf festgelegt
		}
	}

	function nachkomma(value, stellen) {
		  if (value == null) return ''
			if (value.toFixed) {
				value = value.toFixed(stellen)
			  }
			return value
	}

	function nachkomma0oder1 (value) {
		// wenn die Zahl auf "Komma 0" endet, dann gleich ohne Komma darstellen
		if (value.toFixed){
			if (value.toFixed(0)-value.toFixed(1)==0)
				value = value.toFixed(0)
			else
				value=  value.toFixed(1)
		}
		return value
	}

	function format_minutes(min) {
		let days = Math.floor(min/24/60)
		let hours = Math.floor(min/60%24)
		min = Math.floor(min%60)
		let s = ''
		if (days!=0) s+=days.toString()+'T  '
		if (hours!=0) s+=hours.toString()+' Std  '
		if (min!=0) s+=min.toString()+' Min  '
		return s
	}

	function W_to_color(W) {
		if (W<=80) return 'red'
		else if (W<=85) return 'darkred'
		else if (W<=90) return 'darkgray'
		else return 'black'
	}


</script>

<main>

<!-- Ganz oben: Dunkler Streifen oben mit Logo und Slogan -->
<div style=" background-color:#404040; padding:3px; ">
	<div class="limitBreite halbBoxContainer" style="align-items:center;"> <!-- der halbBoxContainer wird hier nur aufgrund seiner Eigenschaften genutzt, die Anzeige zwischen Zeilen- und Spaltenansicht umzustellen -->
		<div>
		<!-- <a href="#" role="button"> -->
		 	<img class="button" src="/static/logo.svg" style="height:40px" alt="logo" on:click={event => {ladebereich_sichtbar=true; rezept=null} }>
			<!-- </a> -->
			</div>
		<div style="color:wheat; font-weight:bold; margin:0 40px">Brotrezepte analysieren & anpassen {Server_debug_msg}</div>

	</div>
</div>


 <!-- center area (eigentliche Seite) -->
<div class="limitBreite">

<div id="loadingAnimation">
	{#if loading==true}
		<div class="spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
	{/if}
</div>


  <!-- IMPORT / VORLAGEN -->
	{#if ladebereich_sichtbar}

	<!-- VON INTERNETSEITE IMPORTIEREN -->
  <div class="untenAbgerundet whiteBackground">
		<h2 style="margin:0">Brotrezept aus dem Internet einlesen</h2>
		<div id="internet" class="rezeptWahl centerContentVertandHoriz" >
			<div class="halbBox" style="text-align:center;">
				Rezept von einer Internetseite (z.B. Brot-Blog) einlesen:<br>
				Tipp: alternativ Zutaten kopieren (s.u.)
			</div>
			<div class="halbBox">
				<input type="url" class="simple-input" placeholder="z.B. https://en.wikipedia.org/wiki/No-knead_bread" style="width:100%"
							 on:change="{event => {update('import_url', event.target.value, []); event.target.value='';} }">
			</div>
		</div>
	</div>

	<!-- Textimport -->
  <div class="untenAbgerundet whiteBackground">
		<h2 style="margin:0">Zutatenliste einlesen</h2>
		<div id="internet" class="rezeptWahl centerContentVertandHoriz" >
			<div class="halbBox" style="text-align:center;">
				Zutaten als Text eingeben. Die Auflistung muss folgende Form haben:
				<div style="font-style:italic">Teigname1<br>Zutat1<br>Zutat2<br><br>Teigname2<br>Zutat3<br>Zutat4</div>
			</div>
			<div class="halbBox">
				 <textarea bind:value={zutaten_text} rows="8" cols="50"></textarea>
			</div>
			<div class="button" style="background-color: #404040; color:wheat; padding:7px"
				   on:click={event => {update('import_text', zutaten_text, []);} }>
				Senden
			</div>
		</div>
	</div>


<!--
	<div id="gespeichertesRezept" class="rezeptWahl defaultHidden">
		<div>Platzhalter</div>
	</div> -->

<!-- VORLAGEN LADEN -->
<div class="obenAbgerundet untenAbgerundet whiteBackground">
	<h2 style="margin:0">Rezeptbeispiele</h2>
	{#each vorlagen as v}
		<div class="halbBoxContainer vorlagenButton" on:click={event => update('rezept_vorlage', v.name, [])}>
			<div class="halbBox" style="font-weight:bold">
				{v.name}
				<div style="font-size:small; font-weight:normal">
					<span class="spanForPreSVG" style="background-image:url(/static/gesamtzeit.svg)"> {format_minutes(v.t_passiv)}  </span>
					 &nbsp; &nbsp;
					<span class="spanForPreSVG" style="background-image:url(/static/anzahl_arbeitsschritte.svg)"> {v.anzahl_schritte} Arbeitsschritte  </span>
				</div>
			</div>
			<div class="halbBox" style="font-size:14px; display:flex; align-items:center; ">
				{v.beschreibung}
			</div>
		</div>
	{/each}
</div>

<!-- LEERES REZEPT ERSTELLEN -->
<div class="untenAbgerundet whiteBackground">
	<h2 style="margin:0">Neues Rezept erstellen</h2>
	<div id="neuesRezept" class="rezeptWahl centerContentVertandHoriz">
		<div class="halbBox" style="text-align:center;">	Name des Brotes:</div>
		<div class="halbBox" style=" ">
			<input class="simple-input" placeholder="z.B. Bestes Brot" style="width:100%" on:change="{event => {update('new_rezept', event.target.value, []); event.target.value=''; } }">
		</div>
	</div>
</div>


<!-- Endes Vorlagenbereichs -->

{/if} <!-- v-if="loading==false" -->

{#if rezept}

<div class="halbBoxContainer"  style="margin-top:10px;">


  <div class="halbBox" id="linkerHauptbereich" style="">
    <!-- Rezeptnamen -->
    <div class="obenAbgerundet whiteBackground centerContentVertandHoriz" style="margin-bottom: 10px; height: 40px; ">
      <h1 style=""> { rezept.rezept_name }</h1>
    </div>



    <!-- Bereich mit Zuatenliste -->
    <div class="untenAbgerundet whiteBackground"  style="min-height:100px">

     <!-- Einheiten wählen -->
     <div style="display:flex; justify-content: flex-end; margin-bottom:-50px;">
       <div><i class="material-icons">square_foot</i></div>
       <div>
         <select bind:value={sel_unit} on:change={event => update('select_unit',sel_unit,[]) } >
           <option value="null" disabled hidden>Einheiten</option>
					 {#if avail_units}
						 {#each avail_units as unit}
             	<option>{unit}</option>
						 {/each}
					 {/if}
         </select>
       </div>
     </div>



      <!-- <div v-for="(teig, teig_index) in rezept.teige" :key="teig_index"> -->
			{#each rezept.teige as teig, teig_index}

        <!-- Name des Subteigs anzeigen -->
        <h2 v-bind:id="teig.name" class="header-margin-top" style="">
          {teig.name}
          <!-- Teig löschen -->
          <img
           src="/static/abfall.png"
					 alt="delete ingredient"
           style="height:18px; vertical-align: middle"
           on:click={event => update('del_teig',0,[teig_index,0])}
           >
        </h2>

        <!-- Teigtemperatur anzeigen -->
        <div style="font-size: 12px; margin-top: -0px; margin-bottom: 4px; color:gray">
          Berechnete Teigtemperatur: {nachkomma(teig.TT_ist,1)}°C {#if teig.TT_soll}(Ziel: {nachkomma(teig.TT_soll,0)}°C){/if}
        </div>


        <ul style="list-style-type: none;">

					{#each teig.zutaten as zutat, zutatIndex}
          	<li>
            <!-- Masse anzeigen/ändern -->
              <LabelInput
                label={nachkomma0oder1(zutat.displayed_m)}
                value={nachkomma0oder1(zutat.displayed_m)}
                minInputWidth="2rem"
                on:mychange={event => update('set_zutat_m', event.detail.value, [teig_index,zutatIndex])}
              ></LabelInput> {sel_unit}

            <!-- Zutat: Bezeichnung -->
						{#if zutat.group=='ref'}&rarr;{/if}
						<!--  <span style={zutat.W<85 ? 'color:darkred' : 'color:black'}  > -->
						 <span style="color:{W_to_color(zutat.W)}"  >
            <LabelInput
              label={zutat.displayed_label}
              value={zutat.displayed_label}
              minInputWidth="100px"
              on:mychange={event => update('set_zutat_label', event.detail.value, [teig_index,zutatIndex])}
            ></LabelInput>
						 </span>

            <!-- Zutat: Temperatur -->
            {#if zutat.displayed_T}({/if}
						<LabelInput
              label={zutat.displayed_T}
              value={zutat.displayed_T}
              afterInputText={zutat.displayed_T ? '' : '°C'}
              labelIcon={zutat.displayed_T ? '' : '/static/thermometer.png'}
              minInputWidth="40px"
              on:mychange={event => update('set_zutat_T', event.detail.value, [teig_index,zutatIndex])}
            ></LabelInput>{#if zutat.displayed_T}°C){/if}

            <!-- Zutat (nur ASG): TA umwandeln -->
						{#if zutat.TA}
            <LabelInput
              label=""
              value={zutat.TA.toString()}
              labelIcon="/static/austausch.png"
              beforeInputText="TA"
              afterInputText="unter Beibehaltung der Teig-TA"
              minInputWidth="40px"
              on:mychange={event => update('mod_ASG_TA', event.detail.value, [teig_index,zutatIndex])}
            ></LabelInput>
						{/if}

            <!-- Zutat löschen -->
            <img
             src="/static/abfall.png"
						 alt="remove ingredient"
             style="height:18px; vertical-align: middle"
             on:click={event => update('del_zutat', 0, [teig_index,zutatIndex])}
             >

          	</li>
					{/each} <!-- Zutaten eines Teiges -->

          <!-- Neue Zutat ergänzen: -->
          <LabelInput
            label="Zutat"
            value=""
            placeholder="z.B. 1,2 g Salz"
            labelIcon="/static/plus.png"
            labelIconHeight="12px"
            labelStyle="text-decoration: none solid black; font-size: 12px; font-weight:700; color:gray"
            minInputWidth="230px"
            on:mychange={event => update('add_zutat', event.detail.value, [teig_index,-1])}
          ></LabelInput>

        </ul>

			{/each} <!-- Teig-Schleife -->


			<!-- Vorteig ergänzen: -->
			<div style="margin: 15px 0">
			<LabelInput
				label="Vorteig"
				value=""
				placeholder="z.B. Autolyse-Teig"
				labelIcon="/static/plus.png"
				labelIconHeight="14px"
				labelStyle="text-decoration: none solid black; font-size: 14px; font-weight:700; color:gray"
				minInputWidth="230px"
				on:mychange={event => update('add_teig', event.detail.value, [])}
			></LabelInput>
			</div>

			{#if rezept.quelle}
      	<span style="font-size: 12px"> Quelle: <a href="{rezept.quelle}" style="color:black">{rezept.quelle}</a></span>
			{/if}

    </div> <!-- Zutatenbereich -->

  </div> <!-- linke halbBox -->






<div class="halbBox" id="rechterHauptbereich" style=""> <!-- Rahmen um rechtes Tool -->

  <div class="obenAbgerundet whiteBackground centerContentVertandHoriz" style="margin-bottom: 10px; height: 40px; ">
   <div style="margin-bottom:10px centerContentVertandHoriz"> <!-- Button-Leiste -->
    <button
      class="menu-button"
      style="background: url('/static/eigenschaften.png') no-repeat;"
      on:click={event => showTool('eigenschaften')}
    ></button>
    <button
      class="menu-button"
      style=" background: url('/static/timetable.png') no-repeat; "
      on:click={event => showTool('timetable')}
    ></button>
    <button
     class="menu-button"
     style="background: url('/static/temperatur.png') no-repeat;"
     on:click={event => showTool('temperatur')}
    ></button>
		<button
     class="menu-button"
     style="background: url('/static/export.png') no-repeat;"
     on:click={event => showTool('export')}
    ></button>
		<!-- <button
     class="menu-button"
     style="background: url('/static/subteig.png') no-repeat;"
     on:click={event => showTool('subteig')}
    ></button> -->
  </div> <!-- Button-Leiste -->
 </div>


 <div class="untenAbgerundet whiteBackground" style="">



  <!-- EIGENSCHAFTEN -->
  <div class="rechte_Anzeige" id="eigenschaften"> <!-- Rahmen -->


		<div class="centerContentVertandHoriz toolboxHeadline">
    	<h1>Eigenschaften</h1>
		</div>

		{#each [...rezept.teige].reverse() as teig, i} <!-- teig_props ist die js-Zusammenfassung der Props von Rezept+Subteigen ||| Neu: [...] macht Kopie vom Array, weil reverse destruktiv ist -->
    <div>

			<hr style="border: 1px solid wheat;">
			{#if i==0}
      	<h2>Brotteig insgesamt ("{ teig.name }")</h2>
			{:else}
				<h2>Nur "{ teig.name }"</h2>
			{/if}
			<hr style="border: 1px solid wheat;">

			<h2 class="header-margin-top">Mengen</h2>
      <table class="eigenschaften-table" style="position:relative; border-spacing: 0.5rem;"> <!-- "position:relative" wegen Ausrichtung der Info-Box -->
        <tr style="">
          <!--ALT: <td> Alle Zutaten: {{prop.m0 | nachkomma0}} g</td> -->

          <!-- Skalieren auf definierten Gesamtteig -->
          <td> Alle Zutaten:
            <LabelInput
                label={nachkomma(teig.props.m0,0)}
                value={nachkomma(teig.props.m0,0)}
                minInputWidth="40px"
                on:mychange={event => update('scale_m0', event.detail.value, [i-1])}
								disabled={i==0 ? false : true}
            ></LabelInput>
            g
          </td>

          <td>Mehl
						{#if i==0}
            <InfoPopup
              text="Folgende Getreideerzeugnisse werden bei diesem Rezept zum Mehl gerechnet: {rezept.final_props.mehl_zutaten}"
            ></InfoPopup>:
						{/if}
            <LabelInput
								label={nachkomma(teig.props.mM,0)}
								value={nachkomma(teig.props.mM,0)}
                minInputWidth="40px"
                on:mychange={event => update('scale_mM', event.detail.value, [i-1])}
								disabled={i==0 ? false : true}
            ></LabelInput>
            g
          </td>
					{#if teig.props.mM_mit_ASG!=teig.props.mM}
          <td>
            Mehl inkl. Anstellgut:
            <LabelInput
								label={nachkomma(teig.props.mM_mit_ASG,0)}
								value={nachkomma(teig.props.mM_mit_ASG,0)}
                minInputWidth="40px"
                on:mychange={event => update('scale_mM_mit_ASG', event.detail.value, [i-1])}
								disabled={i==0 ? false : true}
            ></LabelInput>
            g
          </td>
					{/if}
        </tr>

      </table>

			{#if i==0}
      <div style="display:flex; align-items:center; font-size:0.9rem"> <!-- flex-wrapper -->
        <img src="/static/resize.svg" alt="resize complete recipe" style="display:block; width: 2.5rem; padding:0 0.5rem;">
        <div>
          Brotgröße anpassen: Mengen verändern oder um Faktor
          <!-- Skalieren um Faktor -->
          <input type="text" class="simple-input" style="width:3.5rem; text-align:center" placeholder="z.B. 2"  on:change={event => {update('scale_factor',event.target.value,[]); event.target.value=null} }>
          skalieren
        </div>
      </div> <!-- flex-wrapper -->
			{/if}

      <h2 class="header-margin-top" style="position:relative">
			Teigfeuchtigkeit
			<InfoPopup
				text="Wird aus dem Verhältnis von Wasser zu Mehl berechnet. Zum Wasser werden auch die Wasseranteile aller Zutaten (außer vom Mehl, das ebenfalls einen sehr kleinen Wassergehalt hat) addiert"
			></InfoPopup>:
			</h2>

      <table class="eigenschaften-table">
        <tr>
          <td> Teigausbeute (TA): {nachkomma(teig.props.TA,0)}</td>
          <td> Hydratation: {nachkomma(teig.props.TA-100,0)}%</td>
          <td> Wasser: {nachkomma(teig.props.mW_mit_ASG,0)}g</td>
          <td>Konsistenz: {teig.props.TA_bewertung}</td>
        </tr>
      </table>
			{#if rezept.final_props.hyd_phys}
				Reale Teigfeuchtigkeit (ideal für Brote: 48% - 53%)
				<InfoPopup
					text="Für die Berechnung der anteilige Wassergehalt aller Zutaten berücksichtigt. Praktisch, falls z.B. gekochte Kartoffeln oder Naturjoghurt verwendet werden sollen."
				></InfoPopup>:
				 {nachkomma(rezept.final_props.hyd_phys,1)}
			%{/if}

      <h2 class="header-margin-top" style="position:relative"> <!-- "position:relative" wegen Ausrichtung der Info-Box -->
        Salzgehalt
        <InfoPopup
          text="Empfohlene Salzmengen bezogen auf die Mehlmenge liegen je nach Quelle zwischen 1,3% bis 1,5% (Horst Skobranek - Bäckerei Technologie) bzw. 1,8% bis 2,2% (Lutz Geißler - Brotbackbuch Nr.1).
            Für Vollkornbrote oder bei hoher Wasserhärte sollte der Salzgehalt um 0,3 Prozenpunkte reduziert werden. Bezogen auf den gesamten Teig werden Werte zwischen 1,2% und 1,3% empfohlen."
        ></InfoPopup>:
      </h2>
      <!-- <div class="erklaerung" v-if="i==0"></div> -->
      <table class="eigenschaften-table">
        <tr>
          <td> Salz bzgl. Mehl: {nachkomma(teig.props.Salz_auf_Mehl*100, 2)}%</td>
          <td> Salzgehalt: {nachkomma(teig.props.Salz_auf_Teig*100, 2)}%</td>
          {#if i==0}<td> Einschätzung: {teig.props.Salz_bewertung}</td>{/if}

        </tr>
      </table>
			{#if rezept.final_props.salz_auf_feststoff}Realer Salzgehalt im Teig (ideal: 2,0% - 2.3%): {nachkomma(rezept.final_props.salz_auf_feststoff,1)}%{/if}

      <!-- nur für den Gesamtteig anzeigen-->
			{#if i==0}
        <h2 class="header-margin-top" style="position:relative"> <!-- "position:relative" wegen Ausrichtung der Info-Box -->
          Brennwert
          <InfoPopup
            text={"Beim Backen verliert der Teig etwa 15% seiner Masse durch verdampfendes Wasser. Deshalb hat das fertige Brot einen etwas höheren Energiegehalt als der Teig. Folgende Werte werden für die Berechnung verwendet:" +rezept.final_props.brennwert_daten}
          ></InfoPopup>:
        </h2>

        <table class="eigenschaften-table">
          <tr>
					<td> Brennwert pro 100g Teig: {nachkomma(rezept.final_props.brennwert_summe, 0)} kJ ({nachkomma(rezept.final_props.brennwert_summe/4.1868, 0)} kcal)</td>
					<td> Brennwert pro 100g Brot: {nachkomma(rezept.final_props.brennwert_summe/0.75, 0)} kJ ({nachkomma(rezept.final_props.brennwert_summe/0.75/4.1868, 0)} kcal)</td>
          </tr>
        </table>
      {/if}

      <br><br>
    </div>
		{/each}


  </div> <!-- Rahmen -->



  <!-- TIMETABLE -->
  <div class="rechte_Anzeige defaultHidden" id="timetable"> <!-- Rahmen -->
		<div class="centerContentVertandHoriz toolboxHeadline">
			<h1>Zeitplaner</h1>
		</div>
    <TimeDraw
      schritte={rezept.schritte}
      farbe="#694e23"
      bind:this={TimeDrawRef}
    ></TimeDraw>
  </div> <!-- Rahmen -->

  <!-- TEMPERATUR -->
  <div class="rechte_Anzeige defaultHidden" id="temperatur" style="font-size:14px"> <!-- Rahmen -->
		<div class="centerContentVertandHoriz toolboxHeadline">
			<h1>Teigführung</h1>
		</div>
		<br>
    Umgebungstemperatur (Temperatur der Zutaten):
		<LabelInput
				label={nachkomma(rezept.UT,0)}
				value={nachkomma(rezept.UT,0)}
				minInputWidth="50px"
				on:mychange={event => update('set_UT', event.detail.value, [])}
		></LabelInput>°C


		{#each rezept.teige as teig,teig_index}

			<hr class="header-margin-top" style="border: 1px solid wheat;">
      <h2>{teig.name}:</h2>
			<hr style="border: 1px solid wheat;">
			<div style="margin-left:15px">

			<div class="header-margin-top" >
			Soll-Teigtemperatur: <input type="text" class="simple-input" :key="teig_index" value={nachkomma(teig.TT_soll,0)} placeholder="" on:change={event => update('set_TT_soll', event.target.value, [teig_index])}>°C
			</div>

			<h3 class="header-margin-top" style="">Kneten:</h3>
			{#each knetenBezeichnungen as bezeichnung, ki}
				<label style="display:inline-block">
					<input
						type=radio

						bind:group={teig.kneten.intensity}
						value={ki}
						on:input={event => update('set_kneten_intensity', event.target.value, [teig_index,-1])}
						>{knetenBezeichnungen[ki]}
				</label>
			{/each}


			<div style="margin-top:5px">
				 Dehnen und Falten:
				<LabelInput
						label={teig.kneten.SF_anzahl.toString()}
						value={teig.kneten.SF_anzahl.toString()}
						minInputWidth="40px"
						on:mychange={event => update('set_kneten_SF_anzahl', event.detail.value, [teig_index,-1])}
				></LabelInput> mal

				{#if teig.kneten.SF_anzahl==1} nach {:else if teig.kneten.SF_anzahl>1} alle {/if} <!-- Formulierung "1 mal NACH 30min";   "3 mal ALLE 30min"; "0 mal" -->

				{#if teig.kneten.SF_anzahl>0}
					<LabelInput
							label={teig.kneten.SF_abstand.toString()}
							minInputWidth="40px"
							on:mychange={event => update('set_kneten_SF_abstand', event.detail.value, [teig_index,-1])}
					></LabelInput> Minuten
				{/if}
			</div>

			<!-- REIFE PARAMETER -->
			<h3 class="header-margin-top" style="">Temperaturführung (Teigreife):</h3>
			<ul>
			{#each teig.reifen as subreife, subreife_index}
				<li>
				<!-- Temperatur anpassen -->
				<LabelInput
						label="{subreife.UT.toString()}"
						value="{subreife.UT}"
						minInputWidth="40px"
						on:mychange={event => update('set_UT_reife', event.detail.value, [teig_index,subreife_index])}
				></LabelInput>°C für
				<!-- Dauer anpassen -->
				<LabelInput
						label="{subreife.minuten >0 ? subreife.minuten.toString() : '0'}"
						value={subreife.minuten>0 ? subreife.minuten.toString() : '0'}
						minInputWidth="40px"
						on:mychange={event => update('set_reife_m', event.detail.value, [teig_index,subreife_index])}
				></LabelInput> Minuten
				<!-- Temperaturschritt löschen -->
				<img
				 src="/static/abfall.png"
				 alt="remove temperature step"
				 style="height:18px; vertical-align: middle"
				 on:click={event => update('del_subreife', 0, [teig_index,subreife_index])}
				 >
				</li>
			{/each}
			</ul>
			<!-- Temperaturschritt ergänzen: -->
			<LabelInput
				label="Schritt ergänzen"
				value=""
				beforeInputText="Teig bei einer Temperatur von"
				afterInputText="°C reifen lassen"
				placeholder="z.B. 4"
				labelIcon="/static/plus.png"
				labelIconHeight="12px"
				labelStyle="text-decoration: none solid black; font-size: 12px; font-weight:700; color:gray"
				minInputWidth="80px"
				on:mychange={event => update('add_subreife', event.detail.value, [teig_index,-1])}
			></LabelInput>

			</div> <!-- pro Subteig -->
		{/each} <!-- Schleife für Einstellung der zeitlichen Parameter der Teige -->




		<!-- BACK PARAMETER (nur beim Hauptteig, d.h. rezept) -->
			<h3 class="header-margin-top" style="">Backen:</h3>
			<ul>
			{#if rezept.backen}
				{#each rezept.backen as backstufe, backstufe_index}
					<li>
					<!-- Temperatur anpassen -->
					<LabelInput
							label="{backstufe.UT.toString()}"
							value="{backstufe.UT}"
							minInputWidth="40px"
							on:mychange={event => update('set_UT_backen', event.detail.value, [0,backstufe_index])}
					></LabelInput>°C für
					<!-- Dauer anpassen -->
					<LabelInput
							label="{backstufe.minuten >0 ? backstufe.minuten.toString() : '0'}"
							value={backstufe.minuten>0 ? backstufe.minuten.toString() : '0'}
							minInputWidth="40px"
							on:mychange={event => update('set_backen_m', event.detail.value, [0,backstufe_index])}
					></LabelInput> Minuten
					<!-- Temperaturschritt löschen -->
					<img
					 src="/static/abfall.png"
					 alt="remove temperature step"
					 style="height:18px; vertical-align: middle"
					 on:click={event => update('del_backstufe', 0, [0,backstufe_index])}
					 >
					</li>
				{/each}
			{/if}
			</ul>
			<!-- Temperaturschritt ergänzen: -->
			<LabelInput
				label="Ofenschritt ergänzen"
				value=""
				beforeInputText="Brot bei einer Temperatur von"
				afterInputText="°C backen"
				placeholder="z.B. 350"
				labelIcon="/static/plus.png"
				labelIconHeight="12px"
				labelStyle="text-decoration: none solid black; font-size: 12px; font-weight:700; color:gray"
				minInputWidth="80px"
				on:mychange={event => update('add_backstufe', event.detail.value, [0,-1])}
			></LabelInput>

    </div>  <!-- Rahmen-->


		<!-- EXPORTIEREN -->
	  <div class="rechte_Anzeige defaultHidden" id="export"> <!-- Rahmen -->
			<div class="centerContentVertandHoriz toolboxHeadline">
				<h1>Exportieren</h1>
			</div>
			<textarea value={exported_rezept} rows="30" cols="50"></textarea>

	  </div> <!-- Rahmen -->




			<!-- SUBTEIG ERGÄNZEN -->
	    <!-- <div class="rechte_Anzeige defaultHidden" id="subteig">
	      <h2>Neuen Teig zum Rezept hinzufügen</h2>
	        <br>
	        Teig mit der Bezeichnung
	        <input
	          type="text"
	          class="simple-input"
	          style="width: 200px"
	          placeholder="z.B. Autolyse-Vorteig"
	          on:change={event => update('add_teig',event.target.value, [])}
					> zum Rezept hinzufügen.
	    </div>   -->








</div> <!-- ToolBox unter der Menüleiste -->

</div>  <!-- halbBox -->

</div> <!-- flex Container für die beiden halbBoxen -->

 {/if} <!-- if rezept d.h. der komplette Rezept-Bereich -->

 <div class="obenAbgerundet untenAbgerundet whiteBackground" style="font-size: 12px; text-align:right;">
  <a href="#" style="color:black" on:click={event => impressum_sichtbar=!impressum_sichtbar}> Impressum & Datenschutz </a> <!-- toggle boolean variable -->


 {#if impressum_sichtbar}

<div style="text-align:left">
		<h2>Impressum</h2>
		 Johannes Beetz<br>
		 Roßkampffstr. 12<br>
		 74072 Heilbronn<br>
		 Deutschland<br>
		 Tel.: +491771428425 <br>
		 E-Mail: kontakt@???.de<br> <br>


		<h3>1. Name und Anschrift des Verantwortlichen</h3>
		Der Verantwortliche im Sinne des Datenschutzes ist: <br>
		<br>
		Johannes Beetz<br>
		Roßkampffstr. 12<br>
		74072 Heilbronn<br>
		Deutschland<br>
		Tel.: +491771428425<br>
		E-Mail: kontakt@???.de<br>
		Website: www.???.de<br>

		<h3>2. Allgemeines </h3>
		Personenbezogene Daten sind Angaben über eine bestimmte oder eine bestimmbare Person.
		Personenbezogene Daten werden im Rahmen der Nutzung dieser Internetseite nur erhoben oder verarbeitet, sofern dies für die nutzerfreundliche und technische Bereitstellung
		der angebotenen Leistungen erforderlich ist. Die Rechtsgrundlage für die Verarbeitung der personenbezogenen Daten ergibt sich u.a. aus dem Telemediengesetz und der
		Datenschutz-Grundverordnung (DSGVO). Im Folgenden erhalten Sie weitere Informationen zur Datenverarbeitung.

		<h3>3. Bereitstellung der Internetseite und Erstellung von Logfiles </h3>

		Bei jedem Aufruf dieser Internetseite werden Daten und Informationen vom Computersystem des aufrufenden Rechners automatisiert erfasst.
		Folgende Daten werden hierbei erhoben:
		<ol>
		    <li>Informationen über den Browsertyp und die verwendete Version</li>
		    <li>Das Betriebssystem des Nutzers</li>
		    <li>Den Internet-Service-Provider des Nutzers</li>
		    <li>Die IP-Adresse des Nutzers</li>
		    <li>Datum und Uhrzeit des Zugriffs</li>
		    <li>Websites, von denen das System des Nutzers auf unsere Internetseite gelangt </li>
		    <li>Websites, die vom System des Nutzers über unsere Website aufgerufen werden</li>
		    <li>Eingaben des Nutzers in die bereitgestellten Webmasken</li>
		</ol>

		Die Daten werden zudem in den Logfiles des Systems gespeichert, mittels dessen diese Internetseite betrieben wird. Nicht hiervon betroffen sind die IP-Adressen des Nutzers.
		Die Erfassung der Daten dient dem Zweck die Nutzbarkeit des Angebots zu verbessern, beispielsweise dadurch, dass Suchergebnisse zum eingetragenen Ort bei einer zukünftigen Nutzung
		durch Vorbereiten von Rechenschritten erheblich schneller bereitgestellt werden können. Rechtsgrundlage für die Verarbeitung der Daten ist Art. 6 Abs. 1 lit. f DSGVO.

		Die vorübergehende Speicherung der IP-Adresse durch das System ist notwendig, um eine Auslieferung der Website an den Rechner des Nutzers zu ermöglichen.
		Hierfür muss die IP-Adresse des Nutzers für die Dauer der Sitzung gespeichert bleiben.

		Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind.
		Im Falle der Erfassung der Daten zur Bereitstellung der Website ist dies der Fall, wenn die jeweilige Sitzung beendet ist.

		Die Erfassung der Daten zur Bereitstellung der Website und die Speicherung der Daten in Logfiles ist für den Betrieb der Internetseite zwingend erforderlich.
		Es besteht folglich seitens des Nutzers keine Widerspruchsmöglichkeit.

		<h3>4. Verwendung von Cookies </h3>
		Diese Internetseite verwendet ausschließlich sogenannte Session-Cookies.
		Bei Cookies handelt es sich um Textdateien, die im Internetbrowser bzw. vom Internetbrowser auf dem Computersystem des Nutzers gespeichert werden.
		Die Rechtsgrundlage und das berechtigte Interesse für die Verarbeitung personenbezogener Daten unter Verwendung von Cookies ist Art. 6 Abs. 1 lit. f DSGVO.
		Session-Cookies dienen dazu, eine temporäre Sitzung während der Verwendung der Internetseite einzurichten, die es dem Server ermöglicht,
		mehrere Anfragen des Nutzers zueinander zuzuordnen. Session-Cookies sind daher technisch notwendig und werden nach der Sitzung seitens des aufrufenden Clients gelöscht.
		Cookies werden auf dem Rechner des Nutzers gespeichert und von diesem an unserer Seite übermittelt. Daher haben Sie als Nutzer auch die volle Kontrolle über die Verwendung von Cookies.
		Durch eine Änderung der Einstellungen in Ihrem Internetbrowser können Sie die Übertragung von Cookies deaktivieren oder einschränken.
		Bereits gespeicherte Cookies können jederzeit gelöscht werden. Dies kann auch automatisiert erfolgen. Werden Cookies für unsere Website deaktiviert,
		können möglicherweise nicht mehr alle Funktionen der Website vollumfänglich genutzt werden.

		<h3>5. Recht auf Beschwerde bei einer Aufsichtsbehörde</h3>

		Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs steht Ihnen das Recht auf Beschwerde bei einer Aufsichtsbehörde,
		 insbesondere in dem Mitgliedstaat ihres Aufenthaltsorts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes, zu, wenn Sie der Ansicht sind,
		  dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen die DSGVO verstößt.
		Die Aufsichtsbehörde, bei der die Beschwerde eingereicht wurde, unterrichtet den Beschwerdeführer über den Stand und die Ergebnisse der Beschwerde einschließlich
		 der Möglichkeit eines gerichtlichen Rechtsbehelfs nach Art. 78 DSGVO.

		<br>
		<br>
		Hinweis: einige Teile der Datenschutzerklärung wurden einer <a href="https://www.itm.nrw/lehre/materialien/musterdatenschutzerklaerung/">Musterdatenschutzerklärung</a> entnommen.
</div>
{/if}
 </div> <!-- Impressum-Kasten -->

</div> <!-- limitBreite, d.h. center area -->

</main>

<svelte:head>
	<title>breadCrafter</title>
	<html lang="de" />
	<meta charset="UTF-8">
	<meta name="viewport" content="width=device-width, initial-scale=1">

	<link rel="icon" href="/static/favicon.ico" type="image/x-icon">

	<link href="https://fonts.googleapis.com/css?family=Roboto:300,400,700" rel="stylesheet">  <!-- weights 400: normal, 700: bold -->
	<link href="https://fonts.googleapis.com/css?family=Material+Icons" rel="stylesheet"> <!-- icons als font -->

</svelte:head>


<style>

    :global(body) {
      font-family: 'Roboto', sans-serif;
      background-color: wheat;
      margin: 0;
			padding:0;
    }

    /*  {#  wird für sehr große Bildschirme auf 1280px begrenzt #} */
   .limitBreite {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;  /* {#  horizontal zentrieren (top/bottom left/right) #} */
   }

   #linkerHauptbereich {
      margin-right:5px;
   }
   #rechterHauptbereich {
      margin-left:5px;
   }

   @media screen and (min-width: 1280px) { /* {# 1280; sehr große Bildschirme z.B. 1920 #} */
      .limitBreite {
         /* width: 1280px; */
     }
     .whiteBackground {
       /* box-shadow: 4px 4px 2px grey; */
     }
   }

   @media screen and (max-width: 500px) { /* {# MOBIL #} */
     .halbBoxContainer {
       flex-direction:column; /* sonst row */
     }
     #linkerHauptbereich {
        margin:0;
        margin-bottom:15px; /* margin-bottom, damit in der Mobilansicht ein vertikaler Abstand besteht  */
     }
     #rechterHauptbereich {
        margin:0;
     }
   }

   td {
     padding: 0.5rem;
   }



   .halbBoxContainer {
     display:flex;
   }

   .halbBox {
     flex-grow:1;
     flex-basis:0;
   }

   .obenAbgerundet {
     border-top-left-radius: 7px;
     border-top-right-radius: 7px;
     /*border-radius: 25px 25px 0 0;  top-left, top-right, br, bl */
     padding:10px;
   }
   .untenAbgerundet {
     border-bottom-left-radius: 7px;
     border-bottom-right-radius: 7px;
     padding:10px;
		 margin-top:5px;
   }

   .whiteBackground {
     background-color:white;
   }

   .centerContentVertandHoriz {
     display:flex;
     justify-content:center;
     align-items:center;
   }

	 .vorlagenButton {
     text-align:center;
		 background-color: #f0e6d3;
		 padding:10px;
		 margin: 10px;
		 cursor:pointer;
	 }
	 .vorlagenButton:hover {
		 background-color: wheat;
	 }

	 .spanForPreSVG {
	   line-height: 1;
	   padding-left: 1.7em;
	   background-size: auto 100%;
	   background-repeat: no-repeat;
	 }

    .menu-button {
      border: none;
      cursor: pointer;
      height:43px;
      width: 55px;
      margin-left: 3px;
      background-position: center;
      /* filter: invert(94%) sepia(11%) saturate(2558%) hue-rotate(321deg) brightness(83%) contrast(95%); */
    }

		.rechte_Anzeige {
				min-height: 800px;

		}

		.button {
			cursor: pointer;
		  /*border: none;
		  text-decoration: none;*/

		}

		.toolboxHeadline {  /* Farbige Überschrift der einzelnen Tool-Panels */
			background-color: #cfa563;
		 	color:#404040;
			margin-bottom: 1rem;
		}

    .eigenschaften-table {
      width:100%;
      margin: 5px;
      font-size: 0.9rem;
    }
/*
    .relative {
      position: relative;
    }

      .mass_input {
        text-align: right;
      }
*/



      /* h2 {
        font-size:21px;
        font-weight:700;
        color: #694e23;
        margin-bottom: 15px;
      } */

			h1 { /* Rezeptname */
        font-size:19px;
        font-weight:700;
				margin:0;
      }

      h2 { /* für Rezept-Lade-Variante, Subteig-Name und Broteigenschaften-Zwischenüberschrift  */
        font-size:17px;
        font-weight:700;
				margin:0;
      }

			h3 {
        font-size:15px;
        font-weight:700;
      }

			.header-margin-top {
				margin-top: 1.2rem;
			}

      .defaultHidden {
        display: none;
      }

      .simple-input {
        width:100px;
        border:none;
        border-bottom: 1px solid black;
      }

      ::placeholder {
        color: silver;
        opacity: 1;
      }
      :-ms-input-placeholder {
        color: red;
      }
      ::-ms-input-placeholder {
        color: red;
      }

      /* Menüleiste für Brot-Tools
      .menuItem {  wenn weder hovering noch ausgewählt
        color:#404040;
        background-color: #cfa563;
        font-size: 16px;
        font-weight:700;
        padding: 5px;
        padding-left: 15px;
        padding-right: 10px;
        margin-bottom: 2px;
        border-radius: 5px;
        cursor: pointer;
      }

      .menuItem:hover {
        color:black;
        background-color: #cfa563;
      }

      .menuItem.menuSelected {
        color:#cfa563;
        background-color: #404040;
      } */

    /* tooltip für weiterführende Infos */
/*
    .hoverinfo {
      display: inline-block;
    }
    .hoverinfo .hovertext {
      visibility: hidden;
      font-size: 0.8rem;
      width: 50%;
      background-color: white;
      text-align: center;
      border-radius: 5px;
      border-style: solid;
      border-width: 1px;
      padding: 3px 0;
      position: absolute;
      top:0;
      left:25%;
      z-index: 1;
    }
    .hoverinfo:hover .hovertext {
      visibility: visible;
    }*/



				#loadingAnimation {
					  z-index: 10;
					  /*visibility: hidden;*/
				     position: absolute;
				     top: 50%;
				     left: 50%;
				     margin-left: -32px;
				     margin-top: -32px;
					}
				.spinner {   /*{# Quelle: https://loading.io/css/ #}*/
				  display:inline-block; /* {#  damit "text-align" in #loadingAnimation funktioniert #} */
				  width: 64px;
				  height: 64px;
				}
				.spinner div {
				  transform-origin: 32px 32px;
				  animation: spinner 1.2s linear infinite;
				}
				.spinner div:after {
				  content: " ";
				  display: block;
				  position: absolute;
				  top: 3px;
				  left: 29px;
				  width: 5px;
				  height: 14px;
				  border-radius: 20%;
				  background: #ffb700; /* #ffb700  #050084  */
				}
				.spinner div:nth-child(1) {
				  transform: rotate(0deg);
				  animation-delay: -1.1s;
				}
				.spinner div:nth-child(2) {
				  transform: rotate(30deg);
				  animation-delay: -1s;
				}
				.spinner div:nth-child(3) {
				  transform: rotate(60deg);
				  animation-delay: -0.9s;
				}
				.spinner div:nth-child(4) {
				  transform: rotate(90deg);
				  animation-delay: -0.8s;
				}
				.spinner div:nth-child(5) {
				  transform: rotate(120deg);
				  animation-delay: -0.7s;
				}
				.spinner div:nth-child(6) {
				  transform: rotate(150deg);
				  animation-delay: -0.6s;
				}
				.spinner div:nth-child(7) {
				  transform: rotate(180deg);
				  animation-delay: -0.5s;
				}
				.spinner div:nth-child(8) {
				  transform: rotate(210deg);
				  animation-delay: -0.4s;
				}
				.spinner div:nth-child(9) {
				  transform: rotate(240deg);
				  animation-delay: -0.3s;
				}
				.spinner div:nth-child(10) {
				  transform: rotate(270deg);
				  animation-delay: -0.2s;
				}
				.spinner div:nth-child(11) {
				  transform: rotate(300deg);
				  animation-delay: -0.1s;
				}
				.spinner div:nth-child(12) {
				  transform: rotate(330deg);
				  animation-delay: 0s;
				}
				@keyframes spinner {
				  0% {
				    opacity: 1;
				  }
				  100% {
				    opacity: 0;
				  }
				}




</style>
